class formatter {
  toNumber(str: string, max?: number) {
    str = str.toString();
    str = str.replace(/\./g, ",");
    str = str.replace(/[^0-9,]/g, "");
    str = str.replace(/,/g, ".");

    const dotIndex = str.indexOf(".");
    let beforeDot;
    let afterDot;

    if (dotIndex !== -1) {
      beforeDot = str.substring(0, dotIndex);
      afterDot = str.substring(dotIndex + 1).replace(/\./g, "");
    } else {
      beforeDot = str;
    }

    if (max && Number(beforeDot) > max) {
      beforeDot = beforeDot.slice(0, beforeDot.length - 1);
      alert("Maximálisan megadható érték: " + max);
    }
    if (dotIndex !== -1) {
      str = `${beforeDot}.${afterDot}`;
    } else {
      str = beforeDot;
    }

    return str;
  }

  toPhoneNumber(str: string) {
    str = str.trim().replace(/[^0-9+]/g, "");

    // Add international prefix if missing
    const isPrefix = str.match(/^(0|06|\+36|0036)/);
    if (!isPrefix) {
      str = "+36" + str;
    }

    // Remove extra '+' signs except at the start
    if (str.includes("+")) {
      str = "+" + str.replace(/\+/g, "");
    }
    // Format the phone number
    const digits = str.replace(/[^\d]/g, "");
    let formatted = digits;

    if (digits.startsWith("36")) {
      if (digits[2] === "1") {
        formatted = `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
      } else {
        formatted = `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 11)}`;
      }
    }

    if (digits.startsWith("06")) {
      if (digits[2] === "1") {
        formatted = `${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
      } else {
        formatted = `${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 11)}`;
      }
    }

    formatted = formatted.trimEnd();

    return formatted;
  }

  toMoney(str: string | number, max?: number) {
    str = str.toString();
    str = str.replace(/\./g, ",");
    str = str.replace(/[^0-9,]/g, "");
    str = str.replace(/,/g, ".");

    const dotIndex = str.indexOf(".");
    let beforeDot;
    let afterDot;

    if (dotIndex !== -1) {
      beforeDot = str.substring(0, dotIndex);
      afterDot = str.substring(dotIndex + 1).replace(/\./g, "");
    } else {
      beforeDot = str;
    }

    if (max && Number(beforeDot) > max) {
      beforeDot = beforeDot.slice(0, beforeDot.length - 1);
      alert("Maximálisan megadható érték: " + max);
    }

    if (dotIndex !== -1) {
      str = `${beforeDot}.${afterDot}`;
    } else {
      str = beforeDot;
    }
    str = str.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return str;
  }

  toVatnumber(str: string | number) {
    str = str.toString();
    str = str.replace(/[^0-9A-Za-z-]/g, "").toUpperCase();
    return str;
  }

  toInteger(str: string | number) {
    str = str.toString();
    str = str.replace(/[^0-9]/g, "");
    return str;
  }
}

export const format = new formatter();
